<template>
  <header class="page_header" :class="{'fixed_header':fixed}">
    <div v-if="cleverBack" class="close">
      <a href="#" @click.prevent="cleverBackToList" class="close_button">
        <span>&nbsp;</span>
      </a>
    </div>

    <div v-if="closeButton" class="close">
      <a href="#" @click.prevent="$router.go(-1);" class="close_button"></a>
    </div>

    <slot name="undo"></slot>

    <div v-if="!closeButton && !cleverBack && !undo" class="back">
      <a href="#" @click.prevent="$router.go(-1)" class="chevron left">
        <span>&nbsp;</span>
      </a>
    </div>
    <!-- <div class="close">
      <a href="#" @click.prevent="$router.go(-1)" class="close_button"></a>
    </div>-->
    <div class="text">
      <slot />
    </div>


    <slot name="cart_bar"></slot>
    <!-- <cart-bar /> -->

    <!-- <a class="cart_link" href>
      <section class="flex">
        <i class="material-icons mr-1">shopping_cart</i>
        <span class="hide-at-small">Subtotal: $89</span>
        <div class="chevron hide-at-small"></div>
      </section>
    </a>-->
  </header>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    closeButton: {
      default: false,
      type: Boolean
    },
    undo: {
      default: false,
      type: Boolean
    },
    cleverBack: {
      default: false,
      type: Boolean
    },
    fixed: {
      // for .fixed_header
      default: false,
      type: Boolean
    }
  },
  methods: {
    cleverBackToList() {
      this.$emit("cleverBackToList", {});
    }
  }
};
</script>

<style>
</style>